import { createStyles, makeStyles } from '@material-ui/core/styles';
import Skeleton from '@material-ui/lab/Skeleton';
import { StandardDivProps } from '@sprinx/react-mui-components/StandardDiv';
import withThemeProps from '@sprinx/react-mui-components/withThemeProps';
import clsx from 'clsx';
import React from 'react';
import { Helmet } from 'react-helmet';
import { useRouteMatch } from 'react-router-dom';
import PageHeadline from '../../../@sprinx/react-web/PageHeadline';
import { useUrlToTitleElements } from '../../../api/products/catalogue';
import useTranslateWithFallback from '../../../hooks/useTranslateWithFallback';

export type CataloguePageListHeadlineProps = StandardDivProps<CataloguePageListHeadlineClassKey>;

export type CataloguePageListHeadlineClassKey = 'root';

const themeSettings = { name: 'CataloguePageListHeadline' };
const useStyles = makeStyles(
  createStyles<CataloguePageListHeadlineClassKey, {}>({
    root: {},
  }),
  themeSettings,
);

const CataloguePageListHeadline = React.forwardRef<HTMLDivElement, CataloguePageListHeadlineProps>(
  ({ className, classes: pClasses }, ref) => {
    const classes = useStyles({ classes: pClasses });

    return (
      <div ref={ref} className={clsx(classes.root, className)}>
        <React.Suspense fallback={<Skeleton variant='text' height={92} width='100%' />}>
          <CataloguePageListHeadlineInner />
        </React.Suspense>
      </div>
    );
  },
);

CataloguePageListHeadline.displayName = 'CataloguePageListHeadline';

export default withThemeProps(themeSettings)(CataloguePageListHeadline);

const CataloguePageListHeadlineInner = React.forwardRef<any, {}>((props, ref) => {
  const match = useRouteMatch();
  const titleElements = useUrlToTitleElements(match.url);
  const t = useTranslateWithFallback();
  const [pageTitle, pageHeadline] = (titleElements || []).length
    ? ((sarr) => [
        sarr.join(' | '),
        sarr[sarr.length - 1],
        // <>
        //   {sarr.map((s, i) =>
        //     i < sarr.length - 1 ? (
        //       <span key={i.toString()} style={{ fontSize: '50%' }}>
        //         {s}
        //         {' / '}
        //       </span>
        //     ) : (
        //       <span key={i.toString()}>{s}</span>
        //     ),
        //   )}
        // </>,
      ])(titleElements.map((i) => i.label))
    : ((s) => [s, s])(t('cataloguePage/title'));

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
      </Helmet>
      <PageHeadline ref={ref}>{pageHeadline}</PageHeadline>
    </>
  );
});

CataloguePageListHeadlineInner.displayName = 'CataloguePageListHeadlineInner';
